<ng-container *ngIf="gradeWise; else otherWise">
    <div class="overview overview-gradewise">
        <div class="overview-data">
            <div class="tpheading">
                <h2>{{card_title | translate}}</h2>
                <div class="untill" *ngIf="untillDate">
                    <span>{{"reports.asOf" | translate}}</span>
                    <span class="directionLtr"> {{ untillDate ? untillDate : ''}}</span>
                    <span *ngIf="propertiesCount">, {{propertiesCount}} {{'reports.projectsProperties' | translate}}</span>
                </div>
                <ng-container *ngIf="!untillDate">
                  <ng-container *ngIf="isShowtransactionDate; else showTTMmessage">
                      <div class="until ttm-date">
                          <span>{{"from" | translate}}</span>
                          <span class="ttm-date-span">{{getFormattedDate(minDate)}}</span>
                          <span>{{"reports.to" | translate}}</span>
                          <span class="ttm-date-span">{{getFormattedDate(maxDate)}}</span>
                          <span *ngIf="propertiesCount">, {{propertiesCount}} {{'reports.projectsProperties' | translate}}</span>
                      </div>
                  </ng-container>
                  <ng-template #showTTMmessage>
                      <span>{{"reports.ttm" | translate}}</span>
                      <span *ngIf="propertiesCount">, {{propertiesCount}} {{'reports.projectsProperties' | translate}}</span>
                  </ng-template>

                </ng-container>
            </div>
            <ng-container  *ngTemplateOutlet="graphData?.data?.length > 0 ? gradeData : noRecordsTemplate"></ng-container>
            <ng-template #gradeData>
            <div class="grade-outer">
                <div class="gradelist d-flex justify-content-between" *ngFor="let item of graphData.data">
                    <div class="gsec">
                        <strong>{{item.grade == '-' ? '-' : ('reports.'+item.grade | translate)}}</strong>
                        <span>{{item.grade == '-' ? ('reports.undefined' | translate) : ('reports.grade' | translate)}}</span>
                    </div>
                    <div class="gvalue">
                        <h1 class="directionLtr">
                            <ng-container *ngIf="item.rate">
                                {{item.rate | number: '1.0-1'}}
                                <sup>{{symble}}</sup>
                            </ng-container>
                        </h1>
                        <span class="d-flex justify-content-end">{{item.count ? (item.count | number: '1.0-1') : '-'}} {{'reports.projectsProperties' |
                            translate}}</span>
                    </div>
                </div>
            </div>
            </ng-template>
        </div>
    </div>
</ng-container>
<ng-template #otherWise>
    <div class="overview">
        <div class="overview-data">
            <h2>{{card_title | translate}} <span *ngIf="infoTooltip" class="info-tooltip" matTooltipPosition="above"
                    matTooltipClass="custom-tooltip" [matTooltip]="infoTooltipContent"><img
                        src="assets/images/contact_support.svg" alt=""></span></h2>
            <div class="untill" *ngIf="untillDate && !expectedDate">
                <span class="neight" *ngIf="neighborhood">{{'reports.in' | translate}} {{ neighborhood }}</span>
                <span>{{"reports.asOf" | translate}}</span>
                <span class="directionLtr"> {{ untillDate ? untillDate : ''}}</span>
            </div>
            <ng-container *ngIf="!untillDate">
                <ng-container *ngIf="isShowtransactionDate; else showTTMmessage">
                    <div class="until ttm-date">
                        <span>{{"from" | translate}}</span>
                        <span class="ttm-date-span">{{getFormattedDate(minDate)}}</span>
                        <span>{{"reports.to" | translate}}</span>
                        <span class="ttm-date-span">{{getFormattedDate(maxDate)}}</span>
                    </div>
                </ng-container>
                <ng-template #showTTMmessage>
                    <span>{{"reports.ttm" | translate}}</span>
                </ng-template>
            </ng-container>
            <h5 class="area-name" *ngIf="areaName" [title]="areaName">{{areaName}}</h5>
            <h5 class="expected-date" *ngIf="expectedDate">{{'reports.expectedDateofCompletion' | translate}}</h5>
            <h5 class="expected-date directionLtr" *ngIf="expectedDate">{{expectedDate}}</h5>
            <h1 class="directionLtr">
                <ng-container *ngIf="total_current; else otheroverViewSummary">
                    {{current}}{{symble && symble == '%' ? symble : ''}} <sup class="sup-font">{{symble && symble !==
                        '%' ? symble : ''}}</sup>
                </ng-container>
                <ng-template #otheroverViewSummary>-</ng-template>
            </h1>
            <ng-container *ngIf="bhr_price_sqft">
                <h2 class="directionLtr bhr_price">
                    {{bhr_price_sqft}} <sup class="sup-font">{{bhr_symble_sqft}}</sup>
                </h2>
            </ng-container>

            <ng-container *ngIf="propertiesCount">
                <h3>{{'reports.basedOn' | translate}} {{propertiesCount}} {{'reports.projectsProperties' | translate}}
                </h3>
            </ng-container>
            <ng-container *ngIf="card_sub_title">
                <h3>{{card_sub_title | translate}}
                    <ng-container *ngIf="showTooltip">
                        <i class="contant-icon" matTooltipPosition="above" matTooltipClass="custom-tooltip"
                            [matTooltip]=" toolTipContent | translate"></i>
                    </ng-container>
                </h3>
            </ng-container>
            <ng-container *ngIf="BasedOnRentalsText">
                <h3>{{"reports.basedOnRentalsFor" | translate}} {{rentalsName}}</h3>
            </ng-container>

            <div class="developed" *ngIf="showDeveloped">
                <ng-container>
                    <div>
                        <span>{{"reports.developed" | translate}}</span>
                        <h5 class="developerText" [ngClass]="{'textArabicDevloper': lang === 'ar'}">{{developerText ?
                            developerText :'-'}}</h5>
                    </div>
                </ng-container>

                <ng-container>
                    <div>
                        <span>{{"reports.under_construction" | translate}}</span>
                        <h5 class="underConstructionText" [ngClass]="{'textArabicDevloper': lang === 'ar'}">
                            {{underConstructionText ? underConstructionText :'-'}}</h5>
                    </div>
                </ng-container>
            </div>

        </div>
        <div class="horizontal-progress" *ngIf="graphData && !graphData?.loader">
            <ng-container  *ngTemplateOutlet="graphData?.data?.length ? gradeDataChart : noRecordsTemplate"></ng-container>
            <ng-template #gradeDataChart>
                <ng-container *ngFor="let category of graphData?.data; let i=index;">
                    <div class="progress d-flex align-items-center" *ngIf="category[1]['calculation'] != 0">
                        <h5 [title]="category[0]">{{category[0]}}</h5>
                        <section>
                            <!-- <div class="bar"
                                [ngStyle]="{'min-width': (category[1]['calculation'] > 0 ? category[1]['calculation']+'%' : '2%'), 'opacity': getOpacity(i, getNumber(category[1]['category']) )}">
                            </div> -->

                                <div class="bar"
                                [ngStyle]="{'width': (uniType == UnitTypeEnum.percentage) ? getNumber(category[1]['category'])+'%' : (category[1]['calculation'] > 0 ? category[1]['calculation']+'%' : '2%'), 'opacity': getOpacity(i, getNumber(category[1]['category']) )}">
                                </div>
                            <small class="directionLtr">{{getNumber(category[1]['category']) |
                                number:'1.0-1'}} {{symble}}</small>
                        </section>

                    </div>
                </ng-container>
            </ng-template>
        </div>
        <div *ngIf="graphData?.loader">
            <app-skeleton-loader [reportType]="chartView.overView" [loaderSize]="1"
                [height]="'150px'"></app-skeleton-loader>
        </div>

    </div>
</ng-template>

<ng-template #noRecordsTemplate>
    <div class="data_unavail">
        <span>
            {{"reports.data_not_available" | translate}} <mat-icon role="img"
                class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true"
                data-mat-icon-type="font">equalizer</mat-icon>
        </span>
    </div>

</ng-template>
